import { RedoButton } from "@redotech/arbiter/buttons/redo-button";
import { Card } from "@redotech/arbiter/card";
import { Flex } from "@redotech/arbiter/flex";
import { Text } from "@redotech/arbiter/text";
import { useRequiredContext } from "@redotech/react-util/context";
import { toast } from "@redotech/redo-web/alert";
import { useMutation } from "@tanstack/react-query";
import { memo, useContext } from "react";
import { RedoAdminRpcClientContext } from "../../../app/redo-admin-rpc-client-provider";
import { TeamContext } from "../../team";

export const StorefrontAiOnboarding = memo(function StorefrontAiOnboarding() {
  const rpcClient = useRequiredContext(RedoAdminRpcClientContext);
  const team = useContext(TeamContext);

  const syncShopifyProductsMutation = useMutation({
    mutationFn: async () => {
      if (!team) {
        throw new Error("Team is required");
      }
      return rpcClient.syncShopifyProductsForTeam({ teamId: team._id });
    },
    onSuccess: () => {
      toast("Shopify products sync started", { variant: "success" });
    },
    onError: (error) => {
      const errorMessage =
        error instanceof Error ? error.message : "Unknown error";
      toast(`Failed to sync Shopify products: ${errorMessage}`, {
        variant: "error",
      });
    },
  });

  return (
    <Card borderRadius="md" title="AI onboarding">
      <Flex dir="column" gap="md">
        <Text fontSize="sm" fontWeight="medium">
          Sync Shopify products
        </Text>
        <Text fontSize="xs" textColor="secondary">
          This will sync Shopify products for this team. This is already a
          process that happens via a cron job on a 30 minute schedule. The
          intention of this button is to allow for manual syncs.
        </Text>
        <Flex>
          <RedoButton
            disabled={syncShopifyProductsMutation.isPending}
            hierarchy="primary"
            onClick={() => syncShopifyProductsMutation.mutate()}
            size="sm"
            text={
              syncShopifyProductsMutation.isPending
                ? "Sync started"
                : "Sync Shopify products"
            }
          />
        </Flex>
      </Flex>
    </Card>
  );
});
